import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ palette, fontWeights }: Theme) => ({
  markerButton: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    transform: 'translate(-50%, -100%)',
  },
  clusterBase: {
    transform: 'translate(-50%, -50%)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: palette.common.white,
    fontWeight: fontWeights.medium,
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
    userSelect: 'none',
    cursor: 'pointer',
  },
}));
